import MuiTableCell from '@material-ui/core/TableCell';

import styled from 'styled-components';

export const TableCell = styled(MuiTableCell)`
  padding: 8px;
`;
